<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="24">
        <div class="mb-1">
          <b-badge
            style="font-size: 12px"
            :variant="
              formData.samplePropertiesStatus === 'Y'
                ? 'success'
                : formData.samplePropertiesStatus === 'D'
                ? 'danger'
                : 'primary'
            "
          >
            {{
              formData.v_samplePropertiesStatus
                ? formData.v_samplePropertiesStatus
                : '新增'
            }}
          </b-badge>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            Update：{{ formData.modifyByName ? formData.modifyByName : '--' }}
            at
            {{ formData.modifyDate ? formData.modifyDate : '--' }}
          </span>
        </div>
      </el-col>
    </el-row>
    <el-card
      class="mt-3"
      style="width:859px;height:300px"
      :body-style="{ padding: '0 0 0 0' }"
      shadow="never"
    >
      <div
        style="display: flex;justify-content: space-between;flex-wrap: wrap;"
      >
        <div style="width:166px">
          <div style="width:150px; height:150px" class="mr-2 ml-2">
            <el-image
              :src="
                formData.imageUrl
                  ? $osscdn(formData.imageUrl)
                  : '/image/static/img/nopic.jpg'
              "
              style="width:150px; height:150px"
              @click.stop="onImagePreview(0)"
            >
              <div slot="error" class="image-slot">
                <img
                  src="/image/static/img/nopic.jpg"
                  style="width: 150px; height: 150px"
                />
              </div>
            </el-image>

            <el-upload
              id="uploader"
              ref="uploader"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="uploadChange"
              accept=".jpeg,.jpg,.png,.gif"
            >
              <b-button
                style="width: 156px"
                v-if="!disabled"
                size="sm"
                variant="outline-primary"
                >{{ $l('form_label_image_maintenance') || '图片维护' }}
              </b-button>
            </el-upload>
          </div>
        </div>
        <div style="width:683px">
          <el-form
            ref="form"
            :model="formData"
            :disabled="disabled"
            :rules="rules"
            size="medium"
            label-width="140px"
            label-position="left"
          >
            <div class="el-form-row">
              <el-form-item
                :label="$l('table_label_image_type') || '样品特性图片类型'"
                prop="samplePropertiesType"
              >
                <dict-select
                  size="medium"
                  clearable
                  filterable
                  v-model="formData.samplePropertiesType"
                  :body="{ dictType: 'samplePropertiesType' }"
                  url="/sys/common/dict/system"
                  @change="updateType"
                ></dict-select>
              </el-form-item>
            </div>
            <div class="el-form-row">
              <el-form-item
                :label="$l('table_label_imageCn') || '特性图片中文名称'"
                prop="samplePropertiesName"
              >
                <el-input
                  v-model="formData.samplePropertiesName"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  clearable
                />
              </el-form-item>
            </div>
            <div class="el-form-row">
              <el-form-item
                :label="$l('table_label_imageEn') || '特性图片英文名称'"
                prop="samplePropertiesNameEn"
              >
                <el-input
                  v-model="formData.samplePropertiesNameEn"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  clearable
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
    </el-card>

    <div class="d-flex justify-content-end mt-2 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <div v-show="false" class="fabricImagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="item in listImageUrl"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="item"
      />
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    disabled: { type: Boolean, default: false },
    samplePropertiesImageCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      loading: false,
      formData: {
        samplePropertiesImageCode: '',
        samplePropertiesType: '',
        samplePropertiesName: '',
        samplePropertiesNameEn: '',
        imageCode: '',
        imageUrl: '',
      },
      imageWidth: '',
      imageHeight: '',
      listImage: [],
      imageVisible: true,
      rules: {
        samplePropertiesType: [
          { trigger: 'change', required: true, message: ' ' },
        ],
        samplePropertiesName: [
          { trigger: 'blur', required: true, message: ' ' },
        ],
        samplePropertiesNameEn: [
          { trigger: 'blur', required: true, message: ' ' },
        ],
      },
    }
  },
  mounted() {
    this.loadData()
  },
  computed: {
    isEmpty() {
      return !this.listImage || !this.listImage.length
    },
    listImageUrl() {
      return this.isEmpty ? [] : this.listImage
    },
  },
  methods: {
    async loadData() {
      if (!this.samplePropertiesImageCode) return
      this.loading = true
      const res = await this.$api
        .masterSamplePropertiesDetailApi({
          samplePropertiesImageCode: this.samplePropertiesImageCode,
        })
        .catch(() => {})
      this.loading = false
      this.formData = res.body || {}
      this.listImage = [this.formData.imageUrl]
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const { imageCode, imageUrl } = this.formData
      if (!imageCode || !imageUrl) {
        this.$message.warning('上传图片不能为空!')
        return
      }

      const params = {
        samplePropertiesImageCode: this.samplePropertiesImageCode,
        ...this.formData,
      }
      this.loadingOpen()
      const res = await this.$api
        .masterSamplePropertiesSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      this.close()
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    onImagePreview(index) {
      if (this.isEmpty) return
      const viewer = this.$el.querySelector('.fabricImagesViewer').$viewer
      viewer.view(index)
      viewer.show()
    },

    async uploadChange(file) {
      if (!file) {
        this.$message.warning(
          this.$l('INDEX.tips_upload_file') || '请选择您需要上传的图片！'
        )
        return
      }
      const isLthalf = file.size / 1024 / 1024 < 0.5
      if (!isLthalf) {
        this.$message.warning('上传图片大小不能超过 500K!')
        return
      }
      const image = await new Promise((resolve) => {
        if (!file) {
          return resolve()
        }
        let image
        try {
          image = new Image()
          image.src = this.getObjectURL(file.raw)
        } catch (e) {
          return resolve()
        }
        image.onload = async () => {
          resolve(image)
        }
      })
      if (!image) {
        this.$message.warning('图片异常')
      }
      this.imageWidth = image.width
      this.imageHeight = image.height
      if (this.formData.samplePropertiesType == 'A') {
        if (image.width > 600 || image.height > 600) {
          this.$message.warning('当前图片的尺寸像素限制为600x600')
          return
        }
      }
      this.loadingOpen()
      const imageFile = await this.uploadImages(file)
      if (image == null) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        return
      }
      this.loadingClose()
      this.formData.imageCode = imageFile.imageCode
      this.formData.imageUrl = imageFile.imageUrl
    },
    uploadImages(file) {
      if (!file) {
        return Promise.resolve({})
      }
      const uploadTask = this.$api
        .SYS_UPLOAD(file.raw)
        .then((res) => ({
          imageCode: res.body.fileId,
          imageUrl: res.body.url,
        }))
        .catch(() => {
          this.loadingClose()
          return null
        })
      return uploadTask
    },
    getObjectURL(file) {
      let url = null
      if (window.createObjectURL != undefined) {
        url = window.createObjectURL(file)
      } else if (window.URL != undefined) {
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL != undefined) {
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    updateType(type) {
      if (type == 'A') {
        if (this.imageWidth > 600 || this.imageHeight > 600) {
          this.$confirm(
            '<p>当前样品特性图片类型下，图片像素限制为600x600</p> <p>确认：&nbsp<b>清除</b>&nbsp图片信息</p><p>取消：&nbsp<b>清除</b>&nbsp样品特性图片类型</p>',
            '提示',
            {
              confirmButtonText: this.$l('INDEX.btn_confirm') || '确认',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
              dangerouslyUseHTMLString: true,
              closeOnClickModal: false,
              distinguishCancelAndClose: true,
            }
          )
            .then(() => {
              this.formData.imageUrl = ''
              this.formData.imageCode = ''
              this.imageWidth = 0
              this.imageHeight = 0
            })
            .catch(() => {
              this.formData.samplePropertiesType = ''
            })
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}

.image-wrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-wrapper img {
  max-width: 100%;
  max-height: 100%;
}

::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }

  .el-form {
    .el-form-row {
      display: flex;
      border: 1px solid #ebeef5;
      border-top: none;
      border-left: none;
      .el-form-item {
        margin: 0 !important;
        position: relative;
        width: 100%;

        .el-form-item__label {
          color: #909399;
          background: #fafafa;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          padding: 13px 10px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
          font-size: 13px !important;
          position: absolute;
          bottom: 0;
          top: 0;
        }

        .el-form-item__content {
          padding: 0 5px;
          box-sizing: border-box;
          text-align: left;
          font-weight: 400;
          line-height: 1.5;
          color: #606266;
          font-size: 12px !important;
          > div {
            margin: 3.2px 0;
          }
          > .el-input {
            input[readonly] {
              border: none;
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
        }
      }
    }

    > div:first-child {
      border-top: 1px solid #ebeef5;
    }
  }
}
</style>
